import React, { Component } from 'react';
import { Badge, Container, Row, Col, Card, CardBody, Modal, ModalHeader, ModalBody, CardHeader, CardText, UncontrolledButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem, Button, TabContent, TabPane, Nav, NavItem, NavLink, Form, Input, Label, CardLink, FormGroup, UncontrolledCollapse } from 'reactstrap'
import Header from '../../Componentes/header'
import Navigation from '../../Componentes/nav'
import Footer from '../../Componentes/footer'
import '../../CSS/bootstrap.min.css'
import '../../CSS/style.css'
import Fetch from '../../Auxiliares/fetch'
import { toast } from 'react-toastify'
import { ip } from '../../Auxiliares/ip'
import classnames from 'classnames';
import TarjetaAsignacion from '../../Componentes/Cards/asignacionCard'
import TarjetaAspiranteAdmin from '../../Componentes/Cards/aspiranteAdminCard'

export default class AdminUsuarios extends Component {
    constructor() {
        super();
        this.state = {
            idUsuario: null,
            aspirantes: [],
            documento: '',
            isViewModalOpen: null,
            lista: [],
            ruta: null,
            documentos: [
                { nombre: 'Solicitud de inscripción', ref: null },
                { nombre: 'Acta de nacimiento', ref: null },
                { nombre: 'CURP', ref: null },
                { nombre: 'Documento institucional', ref: null },
                { nombre: 'Fotografía', ref: null },
                { nombre: 'Formato FM9', ref: null },
                { nombre: 'Contrato estudiantil', ref: null },
                { nombre: 'Número de seguro social', ref: null },
            ],

            nombre: null,
            verNombre: null,
            doc: null,
            curp2: null,
            isViewAsignacion: null,
            activeTab: '1',
            addAsignacionAspirante: false,
            usuarios_sin_asignacion: [],
            asignacionAspirante_lista: [],
            aspirantesAsignables: [],
            aspirantesDeAsignacion: [],
            asignacionLista: [],
            isOptionsOpen: false,
            isDelModalOpen: null,
            isModModalOpen: null,
            isEmailModalOpen: null,
            mensajeCorreo: '',
            currentPage: 1, //pagination
            elementsPerPage: 6, //pagination
            isAddAspiranteOpen: false,
            mensajeCorreo: '',

            id: "",
            nombreAspirante: "",
            ap_paterno: "",
            ap_materno: "",
            curp: "",
            ficha: "",
            pago: "",
            sexo: "",
            nacionalidad: "",
            correo: "",
            convocatoria: "",
            convocatorias: [],

            bus_ficha: "",
            bus_nombre: "",
            bus_ap_paterno: "",
            bus_ap_materno: "",
            bus_opcion: "",

            editAspirante: null
        }

        this.handleClick = this.handleClick.bind(this);
        this.actualizarLista = this.actualizarLista.bind(this)

        this.cambiarTab = this.cambiarTab.bind(this)
        this.asignacionAspirante = this.asignacionAspirante.bind(this)
        this.viewAsignacion = this.viewAsignacion.bind(this)
        this.onSeleccionUsuario = this.onSeleccionUsuario.bind(this)
        //this.crearAsignacion = this.crearAsignacion.bind(this)
        this.getAspirantesPorFicha = this.getAspirantesPorFicha.bind(this)
        //this.modificar = this.modificar.bind(this)
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.toogleAddAspirante = this.toogleAddAspirante.bind(this)
    }

    //pagination
    handleClick(event) {
        this.actualizarLista()
        this.setState({
            currentPage: Number(event.target.id)
        });
    }
    //pagination 

    handleKeyPress = e => {
        if (e.key === "Enter") {
            this.buscar();
        }
    }

    buscar(){
        const { bus_ficha, bus_nombre, bus_ap_paterno, bus_ap_materno, bus_opcion } = this.state

        Fetch('/api/consultarAspirante', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ ficha: bus_ficha, ap_paterno: bus_ap_paterno, ap_materno: bus_ap_materno, opcion: bus_opcion })
        })
            .then(response => {
                toast.success("Respuesta!")
            })
            .catch(err => {
                switch (err.status) {
                    case 600:
                        toast.error('Datos no encontrados')
                        break;
                    case 605:
                        toast.info('No existen coincidencias')
                        break;
                    default:
                        toast.error("Se produjo un error de conexion")
                        break;
                }
            })

    }

    setValue(field, ev) {
        this.setState({ [field]: ev.target.value })
    }

    componentDidMount() {
        this.actualizarLista();
    }

    async getAspirantesPorFicha(lista) {
        await Fetch('/api/getAspirantesDeAsignacion', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ lista })
        })
            .then(response => {
                console.log(response.data);
                return response.data
            })
            .catch(err => {
                switch (err.status) {

                    case 600:
                        console.log('Error inesperado')
                        return []

                    default:
                        console.log(err)
                        return []
                }
            })
    }

    viewAsignacion(asig) {
        if (asig) {
            this.setState({ aspirantesDeAsignacion: this.getAspirantesPorFicha(asig.lista), isViewAsignacion: asig })
        } else {
            this.setState({ isViewAsignacion: null })
        }
    }

    actualizarLista() {
        console.log("update")
        Fetch('/api/getAspirantes', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => {
                console.log(response.data)
                this.setState({ aspirantes: response.data })
            })
            .catch(err => {
                switch (err.status) {

                    case 600:
                        console.log('Error inesperado')
                        break;

                    case 605:
                        console.log('Listado de elementos vacia')
                        this.setState({ aspirantes: [] })
                        break;

                    case 630:
                        toast.error("No se encontro ninguna convocatoria activa");
                        break;

                    default:
                        console.log("algo paso")
                        break;
                }
            })

        Fetch('/api/getAspirantesAsignables', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => {
                console.log(response.data)
                this.setState({ aspirantesAsignables: response.data })
            })
            .catch(err => {
                switch (err.status) {

                    case 600:
                        console.log('Error inesperado')
                        break;

                    case 605:
                        console.log('Listado de elementos vacia')
                        this.setState({ aspirantesAsignables: [] })
                        break;

                    default:
                        break;
                }
            })

        Fetch('/api/getAsignacionAspirante', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => {
                this.setState({ asignacionAspirante_lista: response.data })
            })
            .catch(err => {
                switch (err.status) {

                    case 600:
                        console.log('Error inesperado')
                        break;

                    case 605:
                        console.log('Listado de elementos vacia')
                        this.setState({ asignacionAspirante_lista: [] })
                        break;

                    default:
                        break;
                }
            })

        Fetch('/getConvocatorias', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => {
                this.setState({ convocatorias: response.data })
            })
            .catch(err => {
                switch (err.status) {

                    case 600:
                        console.log('Error inesperado')

                    default:
                        console.log(err)
                }
            })
    }

    asignacionAspirante(dato) {
        if (dato) {
            Fetch('/api/getUsuariosSinAsignacion', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' }
            })
                .then(response => {
                    this.setState({ usuarios_sin_asignacion: response.data, idUsuario: response.data[0]._id })
                })
                .catch(err => {
                    switch (err.status) {

                        case 600:
                            console.log('Error inesperado')
                            break;

                        case 605:
                            console.log('Listado de elementos vacia')
                            this.setState({ usuarios_sin_asignacion: [] })
                            break;

                        default:
                            break;
                    }
                })

            this.setState({ addAsignacionAspirante: true })

        } else {
            this.setState({ addAsignacionAspirante: false })
        }
    }


    onSeleccionUsuario(ev) {
        var value = ev.target.options[ev.target.options.selectedIndex].id
        this.setState({ idUsuario: value })
    }

    crearAsignacion() {
        const { idUsuario, lista } = this.state
        Fetch('/api/addAsignacionAspirante', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ idUsuario, lista })
        })
            .then(response => {
                this.actualizarLista()
                this.setState({ addAsignacionAspirante: false, lista: [] })
            })
            .catch(err => {
                switch (err.status) {

                    case 811:
                        toast.error('Identificador de usuario invalido')
                        break;

                    case 812:
                        toast.error('Lista vacia')
                        this.setState({ aspirantes: [] })
                        break;

                    case 601:
                        toast.error('Error, este usuario ya tiene asignacion')
                        this.setState({ aspirantes: [] })
                        break;

                    default:
                        break;
                }
            })
    }

    cambiarTab(tab) {
        this.setState({ activeTab: tab })
    }


    toogleAddAspirante() {
        this.setState(prev => ({ isAddAspiranteOpen: !prev.isAddAspiranteOpen }))
    }

    aceptar = (curp, index) => {
        switch (index) {
            case 0:
                //solicitud
                Fetch('/api/acceptSolicitudAP', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ curp })
                })
                    .then(response => {
                        this.cargarPerfil(curp)
                        this.abrirDocumento()
                    })
                    .catch(err => {
                        switch (err.status) {
                            case 400:
                                toast.error('Error al registrar documento')
                                break;

                            case 600:
                                toast.error('Error generico' + err)
                                break;

                            case 614:
                                toast.error('Error al actualizar información')
                                break;

                            default:
                                toast.error("Se produjo un error de conexion" + err)
                                break;
                        }
                    })
                break;

            case 1:
                //acta de nacimiento
                Fetch('/api/acceptActaNacimientoAP', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ curp })
                })
                    .then(response => {
                        this.cargarPerfil(curp)
                        this.abrirDocumento()
                    })
                    .catch(err => {
                        switch (err.status) {
                            case 400:
                                toast.error('Error al registrar documento')
                                break;

                            case 600:
                                toast.error('Error generico' + err)
                                break;

                            case 614:
                                toast.error('Error al actualizar información')
                                break;

                            default:
                                toast.error("Se produjo un error de conexion" + err)
                                break;
                        }
                    })
                break;

            case 2:
                //curp
                Fetch('/api/acceptActaCurpAP', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ curp })
                })
                    .then(response => {
                        this.cargarPerfil(curp)
                        this.abrirDocumento()
                    })
                    .catch(err => {
                        switch (err.status) {
                            case 400:
                                toast.error('Error al registrar documento')
                                break;

                            case 600:
                                toast.error('Error generico' + err)
                                break;

                            case 614:
                                toast.error('Error al actualizar información')
                                break;

                            default:
                                toast.error("Se produjo un error de conexion" + err)
                                break;
                        }
                    })
                break;

            case 4:
                //documento_institucional
                Fetch('/api/acceptDocumentoInstitucionalAP', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ curp })
                })
                    .then(response => {
                        this.cargarPerfil(curp)
                        this.abrirDocumento()
                    })
                    .catch(err => {
                        switch (err.status) {
                            case 400:
                                toast.error('Error al registrar documento')
                                break;

                            case 600:
                                toast.error('Error generico' + err)
                                break;

                            case 614:
                                toast.error('Error al actualizar información')
                                break;

                            default:
                                toast.error("Se produjo un error de conexion" + err)
                                break;
                        }
                    })
                break;

            case 4:
                //fotografia
                Fetch('/api/acceptFotografiaAP', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ curp })
                })
                    .then(response => {
                        this.cargarPerfil(curp)
                        this.abrirDocumento()
                    })
                    .catch(err => {
                        switch (err.status) {
                            case 400:
                                toast.error('Error al registrar documento')
                                break;

                            case 600:
                                toast.error('Error generico' + err)
                                break;

                            case 614:
                                toast.error('Error al actualizar información')
                                break;

                            default:
                                toast.error("Se produjo un error de conexion" + err)
                                break;
                        }
                    })
                break;

            case 5:
                //forma extranjera
                Fetch('/api/acceptFormaExtranjeroAP', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ curp })
                })
                    .then(response => {
                        this.cargarPerfil(curp)
                        this.abrirDocumento()
                    })
                    .catch(err => {
                        switch (err.status) {
                            case 400:
                                toast.error('Error al registrar documento')
                                break;

                            case 600:
                                toast.error('Error generico' + err)
                                break;

                            case 614:
                                toast.error('Error al actualizar información')
                                break;

                            default:
                                toast.error("Se produjo un error de conexion" + err)
                                break;
                        }
                    })
                break;

            case 6:
                //contrato estudiantil
                Fetch('/api/acceptContratoEstudiantilAP', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ curp })
                })
                    .then(response => {
                        this.cargarPerfil(curp)
                        this.abrirDocumento()
                    })
                    .catch(err => {
                        switch (err.status) {
                            case 400:
                                toast.error('Error al registrar documento')
                                break;

                            case 600:
                                toast.error('Error generico' + err)
                                break;

                            case 614:
                                toast.error('Error al actualizar información')
                                break;

                            default:
                                toast.error("Se produjo un error de conexion" + err)
                                break;
                        }
                    })
                break;

            case 7:
                //nss
                Fetch('/api/acceptNssAP', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ curp })
                })
                    .then(response => {
                        this.cargarPerfil(curp)
                        this.abrirDocumento()
                    })
                    .catch(err => {
                        switch (err.status) {
                            case 400:
                                toast.error('Error al registrar documento')
                                break;

                            case 600:
                                toast.error('Error generico' + err)
                                break;

                            case 614:
                                toast.error('Error al actualizar información')
                                break;

                            default:
                                toast.error("Se produjo un error de conexion" + err)
                                break;
                        }
                    })
                break;

            default:
                break;
        }
    }

    denegar = (curp, index) => {
        switch (index) {
            case 0:
                //solicitud
                Fetch('/api/denySolicitudAP', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ curp })
                })
                    .then(response => {
                        this.cargarPerfil(curp)
                        this.abrirDocumento()
                        this.correoAspirante(curp, 'Solicitud de inscripcion')
                    })
                    .catch(err => {
                        switch (err.status) {
                            case 400:
                                toast.error('Error al registrar documento')
                                break;

                            case 600:
                                toast.error('Error generico' + err)
                                break;

                            case 614:
                                toast.error('Error al actualizar información')
                                break;

                            default:
                                toast.error("Se produjo un error de conexion" + err)
                                break;
                        }
                    })
                break;

            case 1:
                //acta de nacimiento
                Fetch('/api/denyActaNacimientoAP', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ curp })
                })
                    .then(response => {
                        this.cargarPerfil(curp)
                        this.abrirDocumento()
                        this.correoAspirante(curp, 'Acta de nacimiento')
                    })
                    .catch(err => {
                        switch (err.status) {
                            case 400:
                                toast.error('Error al registrar documento')
                                break;

                            case 600:
                                toast.error('Error generico' + err)
                                break;

                            case 614:
                                toast.error('Error al actualizar información')
                                break;

                            default:
                                toast.error("Se produjo un error de conexion" + err)
                                break;
                        }
                    })
                break;

            case 2:
                //curp
                Fetch('/api/denyActaCurpAP', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ curp })
                })
                    .then(response => {
                        this.cargarPerfil(curp)
                        this.abrirDocumento()
                        this.correoAspirante(curp, 'CURP')
                    })
                    .catch(err => {
                        switch (err.status) {
                            case 400:
                                toast.error('Error al registrar documento')
                                break;

                            case 600:
                                toast.error('Error generico' + err)
                                break;

                            case 614:
                                toast.error('Error al actualizar información')
                                break;

                            default:
                                toast.error("Se produjo un error de conexion" + err)
                                break;
                        }
                    })
                break;

            case 3:
                //documento_institucional
                Fetch('/api/denyDocumentoInstitucionalAP', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ curp })
                })
                    .then(response => {
                        this.cargarPerfil(curp)
                        this.abrirDocumento()
                        this.correoAspirante(curp, 'Documento institucional')
                    })
                    .catch(err => {
                        switch (err.status) {
                            case 400:
                                toast.error('Error al registrar documento')
                                break;

                            case 600:
                                toast.error('Error generico' + err)
                                break;

                            case 614:
                                toast.error('Error al actualizar información')
                                break;

                            default:
                                toast.error("Se produjo un error de conexion" + err)
                                break;
                        }
                    })
                break;

            case 4:
                //fotografia
                Fetch('/api/denyFotografiaAP', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ curp })
                })
                    .then(response => {
                        this.cargarPerfil(curp)
                        this.abrirDocumento()
                        this.correoAspirante(curp, 'Fotografia')
                    })
                    .catch(err => {
                        switch (err.status) {
                            case 400:
                                toast.error('Error al registrar documento')
                                break;

                            case 600:
                                toast.error('Error generico' + err)
                                break;

                            case 614:
                                toast.error('Error al actualizar información')
                                break;

                            default:
                                toast.error("Se produjo un error de conexion" + err)
                                break;
                        }
                    })
                break;

            case 5:
                //forma extranjero
                Fetch('/api/denyFormaExtranjeroAP', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ curp })
                })
                    .then(response => {
                        this.cargarPerfil(curp)
                        this.abrirDocumento()
                        this.correoAspirante(curp, 'Forma extranjera')
                    })
                    .catch(err => {
                        switch (err.status) {
                            case 400:
                                toast.error('Error al registrar documento')
                                break;

                            case 600:
                                toast.error('Error generico' + err)
                                break;

                            case 614:
                                toast.error('Error al actualizar información')
                                break;

                            default:
                                toast.error("Se produjo un error de conexion" + err)
                                break;
                        }
                    })
                break;

            case 6:
                //contrato estudiantil
                Fetch('/api/denyContratoEstudiantilAP', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ curp })
                })
                    .then(response => {
                        this.cargarPerfil(curp)
                        this.abrirDocumento()
                        this.correoAspirante(curp, 'Contrato estudiantil')
                    })
                    .catch(err => {
                        switch (err.status) {
                            case 400:
                                toast.error('Error al registrar documento')
                                break;

                            case 600:
                                toast.error('Error generico' + err)
                                break;

                            case 614:
                                toast.error('Error al actualizar información')
                                break;

                            default:
                                toast.error("Se produjo un error de conexion" + err)
                                break;
                        }
                    })
                break;

            case 7:
                //nss
                Fetch('/api/denyNssAP', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ curp })
                })
                    .then(response => {
                        this.cargarPerfil(curp)
                        this.abrirDocumento()
                        this.correoAspirante(curp, 'Número de servicio social')
                    })
                    .catch(err => {
                        switch (err.status) {
                            case 400:
                                toast.error('Error al registrar documento')
                                break;

                            case 600:
                                toast.error('Error generico' + err)
                                break;

                            case 614:
                                toast.error('Error al actualizar información')
                                break;

                            default:
                                toast.error("Se produjo un error de conexion" + err)
                                break;
                        }
                    })
                break;

            default:
                break;
        }
    }

    registrarAspirante() {
        const { nombreAspirante, ap_paterno, ap_materno, curp, ficha, pago, sexo, nacionalidad, correo, convocatoria } = this.state
        Fetch('/api/addAspirante', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ nombre: nombreAspirante, ap_paterno, ap_materno, curp, ficha, pago, sexo, nacionalidad, correo, convocatoria })
        })
            .then(response => {
                this.actualizarLista()
                this.toogleAddAspirante()
            })
            .catch(err => {
                switch (err.status) {

                    case 801:
                        toast.error('Nombre del aspirante invalido')
                        break;

                    case 804:
                        toast.error('Apellido paterno del aspirante invalido')
                        break;

                    case 805:
                        toast.error('Apellido materno del aspirante invalido')
                        break;

                    case 806:
                        toast.error('Curp del aspirante invalido')
                        break;

                    case 807:
                        toast.error('Error, curp ya existente')
                        break;

                    case 808:
                        toast.error('Ficha introducida invalida')
                        break;

                    case 809:
                        toast.error('Error, ficha ya existente')
                        break;

                    case 810:
                        toast.error('Convocatoria introducida invalido')
                        break;

                    case 400:
                        toast.error('Error al registrar aspirante')
                        break;

                    case 600:
                        toast.error('Error generico' + err)
                        break;

                    case 613:
                        toast.error('Error al crear el perfil de aspirante')
                        break;

                    case 612:
                        toast.error('Error al crear al aspirante')
                        break;

                    case 601:
                        toast.error('Error al crear al aspirante, curp ya registrada')
                        break;

                    default:
                        toast.error("Se produjo un error de conexion" + err)
                        break;
                }
            })

    }

    seleccionFicha(e, ficha) {
        if (e.currentTarget.checked) {
            e.target.style.backgroundColor = 'white';
            var array = this.state.lista
            var index = array.indexOf(ficha);
            array.splice(index, 1);
            this.setState({ lista: array })
        } else {
            e.target.style.backgroundColor = 'skyblue';
            var array = this.state.lista
            array.push(ficha);
            this.setState({ lista: array })
        }

        e.currentTarget.checked = !e.currentTarget.checked;
    }

    

    render() {

        //pagination
        const { aspirantes, currentPage, elementsPerPage } = this.state;

        const indexOfLastTodo = currentPage * elementsPerPage;
        const indexOfFirstTodo = indexOfLastTodo - elementsPerPage;
        const currentAspiring = aspirantes.slice(indexOfFirstTodo, indexOfLastTodo);

        const pageNumbers = [];
        for (let i = 1; i <= Math.ceil(aspirantes.length / elementsPerPage); i++) {
            pageNumbers.push(i);
        }
        //pagination


        return (
            <html>
                <Header />
                <Row>
                    <Col className="bg-light" lg="3">
                        <Navigation usuario={sessionStorage.getItem('usuario')} tipo={sessionStorage.getItem('rol')} />
                    </Col>

                    <Col className="bg-light" lg="9">
                        <div id="page-content-wrapper">
                            <div class="container-fluid">
                                <Container>
                                    <Card className="mt-3 mb-3 p-4" >
                                        <h1 className="display-4">Aspirantes</h1>
                                        <p className="lead">Esta seccion permite acceder al listado de aspirantes a nuevo ingreso</p>
                                        <hr className="my-1" />
                                    </Card>

                                    <div >
                                        <Nav tabs style={{ backgroundColor: '#FFFFFF' }}>
                                            <NavItem className="btn">
                                                <NavLink className={classnames({ active: this.state.activeTab === '1' })} onClick={() => this.cambiarTab('1')}>Aspirantes</NavLink>
                                            </NavItem>
                                            <NavItem className="btn">
                                                <NavLink className={classnames({ active: this.state.activeTab === '2' })} onClick={() => this.cambiarTab('2')}>Asignaciones</NavLink>
                                            </NavItem>
                                        </Nav>
                                        <TabContent activeTab={this.state.activeTab} style={{ backgroundColor: '#FFFFFF' }} className="p-3">
                                            <TabPane tabId="1" width="100%">
                                                <Row className="d-inline-block w-100">
                                                    <Col className="text-left mb-2 col-8 invisible" >
                                                        <Button className="p-3 w-25 float-left bg-primary text-dark" id="buscar">Busqueda &#128269;</Button>
                                                    </Col>

                                                    <Col className="text-right col-12 mb-2">
                                                        <Button className="py-3 w-25 float-right bg-light text-dark" onClick={() => this.toogleAddAspirante()}>Agregar Aspirantes</Button>
                                                    </Col>
                                                </Row>

                                                <Row className="text-left col-12 mt-2 invisible">
                                                    <UncontrolledCollapse toggler="#buscar" className="col-12">
                                                        <Card className="p-4 border-0">
                                                            <Form>
                                                                <Row>
                                                                    <Col md="4" xs="12">
                                                                        <FormGroup>
                                                                            <Label>Ficha</Label>
                                                                            <Input type="number" name="bus_ficha" className="col-12" onChange={this.setValue.bind(this, "bus_ficha")} onKeyPress={this.handleKeyPress} value={this.state.bus_ficha} />
                                                                        </FormGroup>
                                                                    </Col>
                                                                    
                                                                    <Col md="4" xs="12">
                                                                        <FormGroup>
                                                                            <Label>Nombre</Label>
                                                                            <Input type="text" name="nombre" className="col-12" onChange={this.setValue.bind(this, "bus_nombre")} onKeyPress={this.handleKeyPress} value={this.state.bus_nombre} />
                                                                        </FormGroup>
                                                                    </Col>

                                                                    <Col md="4" xs="12">
                                                                        <FormGroup>
                                                                            <Label>Apellido Paterno</Label>
                                                                            <Input type="text" name="paterno" className="col-12" onChange={this.setValue.bind(this, "bus_ap_paterno")} onKeyPress={this.handleKeyPress} value={this.state.bus_ap_paterno} />
                                                                        </FormGroup>
                                                                    </Col>
                                                                </Row>


                                                                <Row>
                                                                    <Col md="4" xs="12">
                                                                        <FormGroup>
                                                                            <Label>Apellido Materno</Label>
                                                                            <Input type="text" name="materno" className="col-12" onChange={this.setValue.bind(this, "bus_ap_materno")} onKeyPress={this.handleKeyPress} value={this.state.bus_ap_materno} />
                                                                        </FormGroup>
                                                                    </Col>

                                                                    <Col xs="4">
                                                                        <FormGroup style={{ widht: '100%' }}>
                                                                            <Label>Por documentos</Label>
                                                                            <Input type="select" name="semestre" className="col-12" onChange={this.setValue.bind(this, "bus_opcion")} onKeyPress={this.handleKeyPress} value={this.state.bus_opcion}>
                                                                                <option></option>
                                                                                <option>Todos Aceptados</option>
                                                                                <option>Todos Rechazados</option>
                                                                                <option>Todos Vacios</option>
                                                                                <option>Todos en Revison</option>
                                                                                <option>Almenos un Aceptado</option>
                                                                                <option>Almenos un Rechazado</option>
                                                                                <option>Alemonos uno Vacio</option>
                                                                                <option>Almenos uno en Revision</option>
                                                                            </Input>
                                                                        </FormGroup>
                                                                    </Col>
                                                                    
                                                                    <Col className="text-center my-3">
                                                                        <Row>
                                                                            <Col>
                                                                                <Button className="bg-primary">Buscar</Button>
                                                                            </Col>

                                                                            <Col>
                                                                                <Button className="bg-secondary">Limpiar</Button>
                                                                            </Col>
                                                                        </Row>
                                                                    </Col>
                                                                </Row>
                                                            </Form>
                                                        </Card>
                                                    </UncontrolledCollapse>
                                                </Row>

                                                <Row>
                                                    {currentAspiring.length > 0 ? currentAspiring.map((value) => (
                                                        <Col className="col-4">
                                                            <TarjetaAspiranteAdmin aspirante={value} actualizarLista={this.actualizarLista} convocatorias={this.state.convocatorias}/>
                                                        </Col>
                                                    )
                                                    ) : 'VACIO'}
                                                    <div style={{ overflowX: 'scroll' }}>
                                                        <ul class="pagination" style={{
                                                            whiteSpace: 'nowrap', cursor: 'pointer'
                                                        }}>
                                                            {pageNumbers.map((number) => (
                                                                <li style={{ display: 'inline-block', width: '50px', textAlign: 'center' }}
                                                                    className={number == this.state.currentPage ? "page-item active" : "page-item"}>
                                                                    <a class="page-link"
                                                                        key={number}
                                                                        id={number}
                                                                        onClick={this.handleClick}
                                                                    >
                                                                        {number}
                                                                    </a>
                                                                </li>))}
                                                        </ul>
                                                    </div>
                                                </Row>
                                            </TabPane>

                                            <TabPane tabId="2">
                                                <Row>
                                                    <Col className="col-12 mb-3">
                                                        <Button className="p-3 w-25 float-right bg-light text-dark" onClick={() => this.asignacionAspirante(true)}>Asignacion</Button>
                                                    </Col>

                                                    {Array.from(this.state.asignacionAspirante_lista).length > 0 ? this.state.asignacionAspirante_lista.map(item => (
                                                        <Col className="col-4">
                                                            <TarjetaAsignacion item={item} actualizarLista={this.actualizarLista} aspirantesAsignables={this.state.aspirantesAsignables} />
                                                        </Col>
                                                    )) : 'Vacio'}
                                                </Row>
                                            </TabPane>
                                        </TabContent>
                                    </div>

                                    <Modal isOpen={this.state.isAddAspiranteOpen} toggle={() => this.toogleAddAspirante()}
                                        className="modal-md">
                                        <ModalHeader toggle={() => this.toogleAddAspirante()}>Nuevo Aspirante</ModalHeader>
                                        <ModalBody>
                                            <Row>
                                                <Col>
                                                    <Card className="p-3 text-center">
                                                        <FormGroup >
                                                            <Input className="w-100" type="text" onChange={this.setValue.bind(this, "nombreAspirante")} placeholder="Nombre" name="nombre" value={this.state.nombreAspirante} />
                                                        </FormGroup>

                                                        <FormGroup>
                                                            <Input className="w-100" type="text" onChange={this.setValue.bind(this, "ap_paterno")} placeholder="Apellido Paterno" name="ap_paterno" value={this.state.ap_paterno} />
                                                        </FormGroup>

                                                        <FormGroup>
                                                            <Input className="w-100" type="text" onChange={this.setValue.bind(this, "ap_materno")} placeholder="Apellido Materno" name="ap_materno" value={this.state.ap_materno} />
                                                        </FormGroup>

                                                        <FormGroup>
                                                            <Input className="w-100" type="text" onChange={this.setValue.bind(this, "curp")} placeholder="CURP" name="curp" value={this.state.curp} />
                                                        </FormGroup>

                                                        <FormGroup>
                                                            <Input className="w-100" type="number" onChange={this.setValue.bind(this, "ficha")} placeholder="Ficha" name="ficha" value={this.state.ficha} />
                                                        </FormGroup>

                                                        <FormGroup>
                                                            <Input type="select" name="pago" onChange={this.setValue.bind(this, "pago")} className="w-100" defaultValue={this.state.pago}>
                                                                <option>Pago</option>
                                                                <option value="PENDIENTE">Pendiente</option>
                                                                <option value="RECHAZADO">Rechazado</option>
                                                                <option value="APROBADO">Aprobado</option>
                                                            </Input>
                                                        </FormGroup>

                                                        <FormGroup>
                                                            <Input type="select" name="sexo" onChange={this.setValue.bind(this, "sexo")} className="w-100" defaultValue={this.state.sexo}>
                                                                <option>Sexo</option>
                                                                <option value="M">Hombre</option>
                                                                <option value="F">Mujer</option>
                                                            </Input>
                                                        </FormGroup>

                                                        <FormGroup>
                                                            <Input type="select" name="nacionalidad" onChange={this.setValue.bind(this, "nacionalidad")} className="w-100" defaultValue={this.state.nacionalidad}>
                                                                <option>Nacionalidad</option>
                                                                <option value="M">Mexicana</option>
                                                                <option value="E">Extranjero</option>
                                                            </Input>
                                                        </FormGroup>

                                                        <FormGroup>
                                                            <Input className="w-100" type="text" onChange={this.setValue.bind(this, "correo")} placeholder="Correo" name="correo" defaultValue={this.state.correo} />
                                                        </FormGroup>

                                                        <FormGroup>
                                                            <Input type="select" name="convocatoria" onChange={this.setValue.bind(this, "convocatoria")} className="w-100">
                                                                <option>Convocatoria</option>
                                                                {this.state.convocatorias.map(elem => (
                                                                    <option value={elem.convocatoria}>{elem.convocatoria}</option>
                                                                ))}
                                                            </Input>
                                                        </FormGroup>

                                                        <CardBody>
                                                            <CardLink><Button className="btn-info" onClick={() => this.registrarAspirante()}>Crear</Button></CardLink>
                                                            <CardLink><Button className="btn-light" onClick={() => this.toogleAddAspirante()}>Cancelar</Button></CardLink>
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                            </Row>
                                        </ModalBody>
                                    </Modal>

                                    <Modal isOpen={this.state.addAsignacionAspirante} toggle={() => this.asignacionAspirante()}
                                        className="modal-xl">
                                        <ModalHeader toggle={() => this.asignacionAspirante()}>Crear asignacion de aspirantes</ModalHeader>
                                        <ModalBody>
                                            <Row>
                                                <Col>
                                                    <Card className="border-0">
                                                        <Form className="mx-auto my-auto">
                                                            <Row className="mb-3">
                                                                <Label className="my-auto">Usuario&nbsp;</Label>
                                                                <Input type="select" name="usuario" onChange={(e) => this.onSeleccionUsuario(e)}>
                                                                    {Array.from(this.state.usuarios_sin_asignacion).length > 0 ? this.state.usuarios_sin_asignacion.map(elem => (
                                                                        <option id={elem._id}>{elem.usuario}</option>
                                                                    )) : 'VACIO'}
                                                                </Input>
                                                            </Row>
                                                        </Form>

                                                        <Row>
                                                            {Array.from(this.state.aspirantesAsignables).length > 0 ? Array.from(this.state.aspirantesAsignables).map(ficha => (
                                                                <Col className="col-1">
                                                                    <Button className="py-1 px-3 text-center text-dark mb-2" checked={false} style={{ backgroundColor: 'white' }} onClick={(e) => this.seleccionFicha(e, ficha)}>
                                                                        {ficha}
                                                                    </Button>
                                                                </Col>
                                                            )) : ""}
                                                        </Row>

                                                        <Row className=" text-center mt-3">
                                                            <Col>
                                                                <Button className="btn-success w-75" onClick={() => this.crearAsignacion()}>Guardar</Button>
                                                            </Col>

                                                            <Col>
                                                                <Button className="btn-danger w-75" onClick={() => this.asignacionAspirante()}>Cancelar</Button>
                                                            </Col>
                                                        </Row>

                                                    </Card>
                                                </Col>
                                            </Row>
                                        </ModalBody>
                                    </Modal>

                                    <Modal isOpen={this.state.isDelModalOpen !== null} toggle={() => this.toggleDel()}
                                        className="modal-md">
                                        <ModalHeader toggle={() => this.toggleDel()}>Eliminar</ModalHeader>
                                        <ModalBody>
                                            <Row>
                                                <Col>
                                                    <Card className="p-3 text-center">
                                                        ¿Esta seguro de que desea eliminar esta asignacion?
                                                        <div className="font-weight-bold">
                                                            {this.props.doc}
                                                        </div>
                                                        <CardBody>
                                                            <CardLink><Button className="btn-danger" onClick={() => this.eliminar(this.state.isDelModalOpen)}>Aceptar</Button></CardLink>
                                                            <CardLink><Button className="btn-light" onClick={() => this.toggleDel()}>Cancelar</Button></CardLink>
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                            </Row>
                                        </ModalBody>
                                    </Modal>
                                </Container>
                            </div>
                        </div>
                    </Col>

                </Row>
                <Footer />
            </html>
        )
    }
}

// elem.ref.estado !== 'VACIO' ? // Aceptado | Rechazado
//     <tr>
//         <th>{elem.nombre}</th>
//         <th>{this.estado(elem.ref.estado)}</th>
//         <th>
//             <Button outline color="info" size="sm" onClick={() => this.verDocumento(elem, index)}> Ver Documento </Button>
//         </th>
//     </tr>
//     : // VACIO
//     <tr>
//         <th>{elem.nombre}</th>
//         <th>{this.estado(elem.ref.estado)}</th>
//         <th></th>
//     </tr>
// :
// <tr> {/* REVISION */}
//     <th>{elem.nombre}</th>
//     <th>{"Documento en Revisión"}</th>
//     <th>
//         <Button color="info" size="sm" onClick={() => this.abrirDocumento(elem, index)}> Evaluar Documento </Button>
//     </th>
// </tr>
// }



{/* <Modal isOpen={this.state.isViewAsignacion !== null} toggle={() => this.viewAsignacion()}
className="modal-xl">
<ModalHeader toggle={() => this.viewAsignacion()}>{this.state.isViewAsignacion !== null ? this.state.isViewAsignacion.usuario : ''}</ModalHeader>
<ModalBody>
    <Row>
        {Array.from(this.state.aspirantesDeAsignacion).length > 0 ? this.state.aspirantesDeAsignacion.map(elem => (
            <Col className="col-4">
                <Card className="p-3 px-5 btn">
                    <Row>
                        <Label>Ficha: #&nbsp;</Label>{elem.ficha}
                    </Row>
                </Card>
            </Col>

        )) : ''}
    </Row>
</ModalBody>
</Modal> */}